/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const CopyIcon = ({ width = 10, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 10 12' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.18166 0.515125L9.72452 2.89258C9.90285 3.13595 10 3.43833 10 3.75V8.62745C10 9.38549 9.43716 10 8.74286 10H3.25714C2.56284 10 2 9.38549 2 8.62745V1.37255C2 0.614511 2.56284 0 3.25714 0H7.2C7.5819 0 7.94309 0.189535 8.18166 0.515125ZM7.2 0.833333C7.3191 0.833333 7.44317 0.889833 7.53475 1.00625L9.06175 3.35927C9.07034 3.37251 9.07929 3.38548 9.08859 3.39818C9.15845 3.49351 9.2 3.6175 9.2 3.75V8.62745C9.2 8.9626 8.96031 9.16667 8.74286 9.16667H3.25714C3.03969 9.16667 2.8 8.9626 2.8 8.62745V1.37255C2.8 1.0374 3.03969 0.833333 3.25714 0.833333H7.2ZM0.875 2.41667C0.875 2.18655 0.679125 2 0.4375 2C0.195875 2 0 2.18655 0 2.41667V10.2738C0 11.2342 0.830142 12 1.8375 12H6.5625C6.80412 12 7 11.8135 7 11.5833C7 11.3532 6.80412 11.1667 6.5625 11.1667H1.8375C1.29846 11.1667 0.875 10.7599 0.875 10.2738V2.41667Z'
    />
  </svg>
);

export default CopyIcon;
